import { getUserDailyActivity } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetUserDailyActivity(username) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: [
			"users",
			"unit",
			"course",
			"module",
			"activity",
			"streak",
			`${username}`,
		],
		fn: () => getUserDailyActivity(username),
	});

	const { activity } = data || { activity: [] };

	return { activity, isPending, isSuccess, isError, error };
}
